import type { Party } from '@tankef/core';

import { useClientAuthStore } from '../../stores';

/**
 * Returns the authenticated party (current client user) from the local
 * `clientAuthStore` (zustand, persisted). Sync read — no network.
 *
 * Use this in components that need to compare ownership (e.g. "am I the
 * admin of this relay?"). For a network-refreshed version, use
 * `useCurrentPartyProfile()` from `../client`.
 *
 * Returns `null` if the user isn't authenticated yet.
 */
export function useCurrentUser(): Party | null {
  return useClientAuthStore(s => s.party);
}
